const { useContext } = require('react');
const { default: NotificationStackContext } = require('stores/notification-stack-context');

const useNotifications = () => {
  return useContext(NotificationStackContext);
}

export default useNotifications;